import React, { useState } from "react";

const PolicyPreview = ({ file }) => {
  const [loading, setLoading] = useState(true);

  if (!file) {
    return (
      <div className="text-muted text-center py-5">
        No PDF file available for this policy announcement.
      </div>
    );
  }

  return (
    <div className="p-3" style={{ height: "65vh", position: "relative" }}>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.85)",
            zIndex: 1,
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" />
            <div className="mt-2 small text-muted">Loading PDF preview...</div>
          </div>
        </div>
      )}

      <iframe
        src={file}
        title="Policy PDF Preview"
        style={{ width: "100%", height: "100%", border: "none" }}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default PolicyPreview;
